module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/coj_e-4-5c9b1ee3bb90d45989294d8c60571063.jpg";